import { PlaybookDiagnosticsPlugin } from './plugins/playbook-diagnostics-plugin.js'
import { PlaybookDataPillDiagnosticsPlugin } from './plugins/playbook-datapill-diagnostics-plugin.js'
import { LaneDiagnosticsPlugin } from './plugins/lane-diagnostics-plugin.js'
import { ActivityDiagnosticsPlugin } from './plugins/activity-diagnostics-plugin.js'
import { PlaybookDefinitionPlugin } from './plugins/playbook-definition-plugin.js'
import { PlaybookTriggerInstancePlugin } from './plugins/playbook-trigger-instance-plugin.js'
import { PlaybookTriggerInstanceDiagnosticsPlugin } from './plugins/playbook-trigger-instance-diagnostics-plugin.js'
import { LanePlugin } from './plugins/lane-plugin.js'
import { ActivityPlugin } from './plugins/activity-plugin.js'

// Note: the SDK's plugin injection (FLUENT_INJECT_PLUGINS) uses `prepend` for each
// element, which reverses array order. The plugin that should run FIRST during
// recordsToShapes must therefore be LAST in this array.
export const playbookPlugins = [
    PlaybookDataPillDiagnosticsPlugin,
    LaneDiagnosticsPlugin,
    ActivityDiagnosticsPlugin,
    PlaybookTriggerInstanceDiagnosticsPlugin,
    PlaybookTriggerInstancePlugin,
    LanePlugin,
    ActivityPlugin,
    PlaybookDefinitionPlugin,
    PlaybookDiagnosticsPlugin,
]
